import React from "react";
import Heading from "utils/Heading";
import RichText from "utils/RichText";

const TwoColumnTitleAndText = ({ blok }) => {
  return (
    <div className="my-12 lg:my-24">
      <div className="mx-auto mx-auto">
        <div
          class={`block items-center gap-10 lg:flex lg:flex-row ${
            blok.offset_title ? "" : "mx-auto max-w-7xl"
          }`}
        >
          <div className="w-full lg:w-1/2">
            <Heading
              size="h2"
              className={`relative pl-6 ${
                blok.offset_title
                  ? "left-[-11%] md:left-[-5%] lg:pl-0 "
                  : "text-left lg:pl-12 lg:text-right"
              } font-poppins text-primary font-display !mb-6 !text-[80px]  leading-none tracking-normal lg:!text-[13vw]`}
            >
              {blok.title}
            </Heading>
          </div>
          <div className="prose w-full pl-6 pr-6 text-lg sm:pl-6 lg:w-1/2 lg:pl-12 lg:pr-12">
            <RichText>{blok.content}</RichText>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoColumnTitleAndText;
